<div>
    <!-- ─── Error messages ──────────────────────────────────────────────── -->
    <div class="row" *ngIf="displayBalDueErrMsg">
        <div class="col-md-12 error-block">
            <span class="error-block">{{ 'PAY_AMOUNT_CANNOT_BE_BLANK' | translate }}</span>
        </div>
    </div>

    <!-- ─── Top row: Account dropdown + Payment card ───────────────────── -->
    <div class="row account-row row-affix">

        <!-- Account selector -->
        <div class="col-md-6">
            <div class="account-info well">
                <img class="icon" src="../../../../assets/images/square-exclamation.svg" alt="clock-icon" />
                <label>{{ 'PLEASE_ALLOW_UPTO' | translate }}
                    <span class="bold">{{ 'ALLOWABLE_HOURS' | translate }}</span>
                    {{ 'REFLECTED_RECEIVED_PAYMENTS' | translate }}
                </label>
            </div>


        </div>

        <!-- Payment totals card -->
        <div class="col-md-6">
            <div class="card shadow payment-card">
                <div class="col-sm-12 amount-name-card d-flex align-items-center">
                    <label class="tot-pay-label">{{ 'TOTAL_PAYMENT_KEY' | translate }}</label>
                </div>

                <!-- CAD -->
                <div (click)="setPaymentCurrency('cad')"
                    [class]="paymentCurrency === 'CAD' ? 'amount-card-focus amount-card shadow' : 'amount-card'">
                    <input class="form-radio-input" type="radio" name="invSumPaymentCurrency" value="CAD"
                        [(ngModel)]="paymentCurrency" [ngModelOptions]="{ standalone: true }"
                        aria-label="CAD" tabindex="0" />
                    <label [class]="paymentCurrency === 'CAD' ? 'total-amt-font-focus' : 'total-amt-font'">
                        {{ getSelectedCADTotal() | currency }} (CAD)
                    </label>
                    <img src="../../../../assets/images/CAN FLAG.svg" alt="flag" />
                </div>

                <!-- USD -->
                <div (click)="setPaymentCurrency('usd')"
                    [class]="paymentCurrency === 'USD' ? 'amount-card-focus amount-card shadow' : 'amount-card'">
                    <input class="form-radio-input" type="radio" name="invSumPaymentCurrency" value="USD"
                        [(ngModel)]="paymentCurrency" [ngModelOptions]="{ standalone: true }"
                        aria-label="USD" tabindex="0" />
                    <label [class]="paymentCurrency === 'USD' ? 'total-amt-font-focus' : 'total-amt-font'">
                        {{ getSelectedUSDTotal() | currency }} (USD)
                    </label>
                    <img src="../../../../assets/images/US FLAG.svg" alt="flag" />
                </div>

                <!-- Invoice count + Pay Now -->
                <div class="col-sm-12 d-flex align-items-center pay-card button-card">
                    <div class="col-sm-6">
                        <label class="no-inv-label">{{ 'QUICK_PAY_NUMBER_OF_INVOICES_TEXT' | translate }} :
                            {{ getSelectedInvoiceLength() }}
                        </label>
                    </div>
                    <div class="col-sm-6 d-flex justify-content-end">
                        <button type="button" class="btn btn-primary pay-btn" tabindex="0"
                            [disabled]="getSelectedInvoiceLength() === 0 || !paymentCurrency || isViewOnly"
                            (click)="viewCart()"
                            (keydown.enter)="viewCart()">
                            {{ 'PAY_NOW' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ─── Open Invoices tab header ────────────────────────────────────── -->
    <div class="col-md-12 tab-header-row" role="tabpanel" aria-labelledby="account-panel">
        <div role="tablist">
            <span role="presentation">
                <a role="tab" class="open-invoice active" tabindex="0" href="javascript:void(0)">
                    {{ 'OPENED_INVOICES_TEXT' | translate }} ({{ getInvlocesCount(filteredList) }})
                </a>
            </span>
        </div>
    </div>

    <!-- ─── Search / filter bar (mirrors PIN-level view) ───────────────────── -->
    <div class="col-md-12 filter-tab d-flex">
        <div class="col-md-6 d-flex">
            <!-- Currency filter -->
            <div class="col-md-5 d-flex flex-column currency-check">
                <label class="filter-label">{{ 'CURRENCY_TEXT' | translate }}</label>
                <div class="d-flex">
                    <label class="radio-inline d-flex align-items-center">
                        <input type="checkbox" [(ngModel)]="isCAD" [ngModelOptions]="{ standalone: true }"
                            (change)="applyFilters()" (keydown.enter)="selectCheckBox($event)"
                            aria-label="CAD" />
                        <span class="p-left-5 currency-font">CAD</span>
                        <img alt="cad" class="flag-img margin-right-10"
                            src="../../../../assets/images/CAN FLAG.svg" />
                    </label>
                    <label class="radio-inline d-flex align-items-center">
                        <input type="checkbox" [(ngModel)]="isUSD" [ngModelOptions]="{ standalone: true }"
                            (change)="applyFilters()" (keydown.enter)="selectCheckBox($event)"
                            aria-label="USD" />
                        <span class="p-left-5 currency-font">USD</span>
                        <img alt="usd" class="flag-img p-left-5" src="../../../../assets/images/US FLAG.svg" />
                    </label>
                </div>
            </div>

            <!-- Date range filter -->
            <div class="col-md-4 d-flex align-items-center">
                <div class="form-floating w-100">
                    <select class="form-select date-select" id="invSumDateRange"
                        [ngModel]="invoiceDateRange" [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="onDateRangeChange($event)">
                        <option [ngValue]="0">{{ 'All' | translate }}</option>
                        <option [ngValue]="1">{{ 'PAST_MONTH' | translate }}</option>
                        <option [ngValue]="3">{{ 'PAST_3_MONTH' | translate }}</option>
                        <option [ngValue]="6">{{ 'PAST_6_MONTH' | translate }}</option>
                        <option [ngValue]="12">{{ 'PAST_1_YEAR' | translate }}</option>
                        <option [ngValue]="24">{{ 'PAST_2_YEAR' | translate }}</option>
                    </select>
                    <label for="invSumDateRange">{{ 'DATE_RANGE' | translate }}</label>
                </div>
            </div>
        </div>

        <!-- Invoice # search -->
        <div class="col-md-6 d-flex justify-content-end align-items-center">
            <div class="form-group search-term">
                <div class="input-group">
                    <div class="form-floating search-input margin-right-10">
                        <input type="text" id="invSumSearchTerm" class="form-control" maxlength="50"
                            [(ngModel)]="searchField" [ngModelOptions]="{ standalone: true }"
                            (keydown.enter)="applyFilters()"
                            placeholder="{{ 'INV_SMRY_PLACE_HOLDER_KEY' | translate }}" />
                        <label for="invSumSearchTerm">{{ 'INV_SMRY_PLACE_HOLDER_KEY' | translate }}</label>
                    </div>
                    <div class="input-group-addon searchButton margin-right-10">
                        <button type="button" class="btn btn-primary btn-block primary-btn searchbtn h-56"
                            (click)="applyFilters()">
                            {{ 'SEARCH_KEY' | translate }}
                        </button>
                    </div>
                    <div class="input-group-addon searchButton margin-right-10">
                        <button type="button" class="btn blue-bg sec-btn btn-border h-56"
                            (click)="clearSearch()">
                            {{ 'RESET_KEY' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <!-- ─── Invoice table ───────────────────────────────────────────────── -->
    <div class="tab-content acct-summy-tbl w-100 table-responsive">
        <div class="account-header">
            <label style="text-align:center; font-weight:700; font-size:18px; color:#111">
                {{ 'ACCOUNT_NAME' | translate }} - {{ 'ACCOUNT_TEXT_AUTOPAY' | translate }}
            </label>
        </div>

        <table class="table table-responsive table-striped w-100" aria-describedby="invoice summary table"
            role="table">
            <thead>
                <tr>
                    <!-- Select all -->
                    <th scope="col" class="w-checkb">
                        <input type="checkbox" [(ngModel)]="checkAllInvoices"
                            [ngModelOptions]="{ standalone: true }"
                            (change)="selctAllInvoices()"
                            (keydown.enter)="selectCheckBox($event)"
                            [ngbTooltip]="checkAllInvoices
                                ? ('REMOVE_ALL_INVOICES_TO_CART' | translate)
                                : ('ADD_ALL_INVOICES_TO_CART' | translate)"
                            aria-label="select all invoices" />
                    </th>
                    <th scope="col" class="w-lob">
                        <span class="table-header-text">{{ 'INVOICE_NUMBER' | translate }}</span>
                    </th>
                    <th scope="col" class="w-invdate">
                        <span class="table-header-text">{{ 'INVOICE_DATE' | translate }}</span>
                    </th>
                    <th scope="col" class="w-duedate">
                        <span class="table-header-text">{{ 'DUE_DATE' | translate }}</span>
                    </th>
                    <th scope="col" class="w-invamt">
                        <span class="table-header-text">{{ 'INVOICE_AMOUNT' | translate }}</span>
                    </th>
                    <th scope="col" class="w-baldue text-right">
                        <span class="table-header-text">{{ 'BALANCE_DUE' | translate }}</span>
                    </th>
                    <th scope="col" class="w-crr text-center">
                        <span class="table-header-text">{{ 'CURRENCY_TEXT' | translate }}</span>
                    </th>
                    <th scope="col" class="w-paymntamnt">
                        <span class="table-header-text">{{ 'TL_PAYAMNT' | translate }}</span>
                    </th>
                    <th scope="col" class="w-tablrow">
                        <span class="table-header-text">{{ 'STATUS' | translate }}</span>
                    </th>
                    <th class="w-pdf">
                        <span class="table-header-text-last">{{ 'VIEW_PRINT_KEY' | translate }}</span>
                    </th>
                </tr>
            </thead>

            <tbody>
                <!-- Account grouping via accordion (same as existing view) -->
                <tr *ngFor="let name of visibleAccountName | paginate: { itemsPerPage: 5, currentPage: p }">
                    <td colspan="10" class="padding-0">
                        <ngb-accordion>
                            <ngb-panel>
                                <ng-template ngbPanelTitle>
                                    <label class="title-label-text">{{ name[0] }} - {{ name[1] }}</label>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <!-- Flat invoice rows — NO sub-accordion for PINs -->
                                    <div *ngFor="let invoice of filteredList; index as i">
                                        <table class="table table-responsive w-100 inher"
                                            *ngIf="name[1] === invoice.accounts['accountNumber']"
                                            aria-describedby="invoice row">
                                            <tr [class]="i % 2 === 0 ? 'even-color' : 'odd-color'">

                                                <!-- Checkbox at invoice level -->
                                                <td class="w-checkb">
                                                    <input class="checkb-input" type="checkbox"
                                                        [(ngModel)]="invoice.isChecked"
                                                        [ngModelOptions]="{ standalone: true }"
                                                        (change)="updateInvoiceSelection(invoice)"
                                                        (keydown.enter)="selectCheckBox($event)"
                                                        tabindex="0"
                                                        [ngbTooltip]="invoice.isChecked
                                                            ? ('REMOVE_INVOICE_FROM_CART' | translate)
                                                            : ('ADD_INVOICE_TO_CART' | translate)" />
                                                </td>

                                                <td class="w-lob">{{ invoice['invoiceNumber'] }}</td>
                                                <td class="w-invdate">{{ invoice.invoiceDate }}</td>
                                                <td class="w-duedate">{{ invoice.dueDate }}</td>
                                                <td class="w-invamt text-right">{{ invoice['invoiceAmount'] | currency }}</td>
                                                <td class="w-baldue text-right">{{ invoice['balanceDue'] | currency }}</td>

                                                <td class="w-crr text-center">{{ invoice['currency'] }}</td>

                                                <!-- Editable payment amount (mirrors PIN-level field) -->
                                                <td class="invoice-paymentAmountCell w-paymntamnt text-right">
                                                    <input class="form-control align-right currency pin-amount-width"
                                                        [disabled]="!invoice.isChecked"
                                                        [(ngModel)]="invoice.paymentAmount"
                                                        [ngModelOptions]="{ standalone: true }"
                                                        type="text"
                                                        (keyup)="updatePaymentAmountInvoice(invoice)"
                                                        obppTwoDigitDecimaNumber />
                                                </td>

                                                <td class="w-tablrow">
                                                    {{ invoice['balanceDue'] > 0
                                                        ? (invoice['invoiceStatus'] === 'Partial Payment'
                                                            ? ('PARTIAL_PAYMENT' | translate)
                                                            : (invoice['invoiceStatus'] === 'Open'
                                                                ? ('OPEN' | translate)
                                                                : ('CLOSED' | translate)))
                                                        : ('CLOSED' | translate) }}
                                                </td>

                                                <!-- PDF download -->
                                                <td class="w-pdf">
                                                    <button
                                                        attr.aria-label="PDF Invoice {{ invoice['invoiceNumber'] }}"
                                                        class="btn btn-primary white-bg text-bold-14 pdf-button"
                                                        (click)="getInvoicePDF(invoice['invoiceNumber'])"
                                                        aria-label="pdf-download-icon">
                                                        <span class="sr-only">{{ invoice['invoiceNumber'] }}</span>
                                                        <img src="assets/images/icon-pdf-red.png" alt=""
                                                            class="m-right-10 p-left-2" title="PDF" tabindex="0" />
                                                    </button>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </ng-template>
                            </ngb-panel>
                        </ngb-accordion>
                    </td>
                </tr>

                <!-- Empty state -->
                <tr *ngIf="filteredList.length <= 0">
                    <td colspan="10" class="text-center">
                        <span class="txt-puro-red">{{ 'NO_OPEN_INVOICES_TEXT' | translate }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Pagination -->
    <pagination-controls
        (pageChange)="p = $event"
        class="text-center"
        [previousLabel]="'PREVIOUS' | translate"
        [nextLabel]="'NEXT' | translate">
    </pagination-controls>
</div>
